import React from 'react';
import './legal.css';
import Footer from 'components/Footer/Footer';
import { SEOHelmet, BreadcrumbList } from 'components/SEO';

const PrivacyPolicy = () => {
  return (
    <>
        <SEOHelmet
          title="Privacy Policy - TradeMagic"
          description="TradeMagic's privacy policy. Learn how we collect, use, and protect your data when trading Magic: The Gathering cards."
          canonical="https://trademagic.gg/privacy"
          type="website"
        />

        <BreadcrumbList
          breadcrumbs={[
            { name: 'Home', url: 'https://trademagic.gg' },
            { name: 'Privacy Policy', url: 'https://trademagic.gg/privacy' },
          ]}
        />

        <div className="legal-wrapper">
            <div className="legal-content">
                <h1>Privacy Policy</h1>
                <p><strong>Effective Date: June 24, 2025</strong></p>

                <p>This Privacy Policy describes how TradeMagic.gg collects, uses, and discloses your personal data.</p>

                <h2>1. Data We Collect</h2>
                <ul>
                    <li>Name, username, shipping address, phone number, email, and avatar</li>
                    <li>Have/Want lists, trade history, and platform usage data</li>
                    <li>Email addresses are also collected for account creation, communication, and managing your wish list and subscription preferences</li>
                </ul>

                <h2>2. How We Use Your Data</h2>
                <ul>
                    <li>To operate and improve the service</li>
                    <li>To facilitate trades and maintain user profiles</li>
                    <li>To communicate with you (notifications, updates)</li>
                    <li>To manage your wishlist functionality and account preferences</li>
                </ul>

                <h2>3. Sharing of Information</h2>
                <ul>
                    <li>We do not sell your personal data.</li>
                    <li>Data may be shared with third-party providers (e.g., Stripe, analytics tools) solely to operate the service.</li>
                </ul>

                <h2>4. Public Profile Visibility</h2>
                <ul>
                    <li>Your user profile, including username, avatar, and trading lists, may be publicly visible to other users.</li>
                    <li>Profile information necessary for platform use may be displayed to enable trading, community feedback, and transparency.</li>
                </ul>

                <h2>5. Global Availability</h2>
                <ul>
                    <li>Our services are available globally and data may be transferred to and processed in countries other than your own.</li>
                </ul>

                <h2>6. Security</h2>
                <ul>
                    <li>We implement reasonable safeguards to protect user data.</li>
                    <li>No system is completely secure; use the platform at your own risk.</li>
                </ul>

                <h2>7. Data Retention</h2>
                <ul>
                    <li>We retain user data as long as your account is active or as needed to comply with legal obligations.</li>
                </ul>

                <h2>8. Your Rights</h2>
                <ul>
                    <li>You may request to update, access, or delete your personal data by contacting support.</li>
                </ul>

                <h2>9. Children</h2>
                <ul>
                    <li>We do not knowingly collect personal data from children under 13.</li>
                </ul>

                <h2>10. Changes to Policy</h2>
                <ul>
                    <li>We may update this Privacy Policy. The most recent version will always be posted on our website.</li>
                </ul>

                <h2>11. Contact</h2>
                <p>For privacy-related inquiries: <a href="mailto:support@trademagic.gg">support@trademagic.gg</a></p>
            </div>
        </div>
    <Footer/>
    </>
  );
};

export default PrivacyPolicy;
